module.exports = __webpack_public_path__ + "img/director-work-icon1.4ba62b0e.png";